import { useEffect } from 'react'
import refiner from 'refiner-js'

import { useMe } from 'src/hooks'

import getFullName from './utils/getFullName'

refiner('setProject', process.env.REACT_APP_REFINER_PROJECT)

export function useRefiner() {
  const me = useMe()
  const { id, email, refinerSignature } = me || {}
  const name = getFullName(me)

  useEffect(() => {
    if (!id) return () => {}

    refiner(
      'identifyUser',
      {
        id,
        email,
        name,
      },
      {
        signature: refinerSignature,
      }
    )

    return () => refiner('resetUser')
  }, [id, email, name, refinerSignature])
}
